import { isEqual } from 'lodash';

export const getLocalStorage = (key = '') => {
  try {
    const serializedItem = localStorage.getItem(key);
    if (serializedItem === null) {
      return undefined;
    }
    return JSON.parse(serializedItem);
  } catch (err) {
    return undefined;
  }
};

export const updateLocalStorage = (stateToPersist) => {
  try {
    Object.keys(stateToPersist).forEach((key) => {
      const value = stateToPersist[key];

      /*
        Persisting "nothing" means REMOVING the key, not writing the string "null" over it. Without
        this branch, logging out wrote the token straight back: the action creator removed the key
        and the reducer's sync put a value back under it in the same dispatch.
      */
      if (value === null || value === undefined) {
        localStorage.removeItem(key);
        return;
      }

      const persistedState = getLocalStorage(key);
      if (!persistedState || !isEqual(persistedState, value)) {
        localStorage.setItem(key, JSON.stringify(value));
      }
    });
  } catch (err) {
    // Ignore errors
  }
};

export const prefixedKey = (key) => `RUBIX-${key.toUpperCase()}`;
